import { OnlineOrder, OrderingCategory } from 'kiolyn-api';
import moment from 'moment';
import { timestampFormat } from '../models/Constants';

export default function calculateCategorySchedules(
  category: OrderingCategory | undefined,
  order?: OnlineOrder,
  delayTime?: number,
  deliveryTime?: number
) {
  if (category === undefined) return '';

  const schedules = category?.schedules;
  const unavailableMessage =
    category?.schedules?.unavailable_message ??
    'Sorry! This item is unavailable right now';

  if (schedules?.always_available === false) {
    let date = moment();
    if (
      order !== undefined &&
      order.is_asap === false &&
      order.time !== undefined
    ) {
      date = moment(order.time, timestampFormat);
      if (order.order_type === 'delivery') {
        date = date.add(-((delayTime ?? 0) + (deliveryTime ?? 0)), 'minutes');
      }
    }

    const availableHour = schedules?.available_hours?.find(
      h => h.day_of_week === date.weekday()
    );

    if (availableHour?.is_available) {
      const currentDateObject = {
        year: date.get('year'),
        month: date.get('month'),
        date: date.get('date')
      };

      const from1 = moment(availableHour.from_1, 'HH:mm');
      from1.set(currentDateObject);
      const to1 = moment(availableHour.to_1, 'HH:mm');
      to1.set(currentDateObject);
      const from2 = moment(availableHour.from_2, 'HH:mm');
      from2.set(currentDateObject);
      const to2 = moment(availableHour.to_2, 'HH:mm');
      to2.set(currentDateObject);

      if (
        !(date.isAfter(from1) && date.isBefore(to1)) &&
        !(date.isAfter(from2) && date.isBefore(to2))
      ) {
        return unavailableMessage;
      }
    } else {
      return unavailableMessage;
    }
  }

  return '';
}
